export default {
	headerPanel: 'Příkaz k neinkasní intervenci',
	headerSection: 'Příkaz k neinkasní intervenci ke smlouvě č.:',
	printDate: 'Datum tisku',
	salesRepresentative: 'Obchodní zástupce',
	agency: 'Agentura',
	taskId: 'Číslo úkolu',
	dateTaskCreated: 'Úkol vytvořen dne',
	nameInsurer: 'Jméno pojištěného',
	policyNumber: 'Číslo pojistky',
	street: 'Ulice a č.p.',
	city: 'Obec',
	policyType: 'Druh pojištění',
	dateDealInsurance: 'Datum sjednání pojištění',
	PSC: 'PSČ',
	thing: 'Věc',
	assigner: 'Vyřizuje:',
	dateToAssign: 'Vyřídit do:',
	typeOfAssign: 'Způsob vyřízení',
	doneContractContinue: 'Vyřízeno - smlouva pokračuje',
	doneContractCancel: 'Vyřízeno - výpověď smlouvy',
	doneNein: 'NEIN vystavena neoprávněně',
	reasonCancelation: 'Důvod [výpovědi smlouvy]/[odebrání]: *Nehodící se škrtněte',
};
